import { AgencyBanner } from '@/app/donation/_components/AgencyBanner';

import { HeroImage } from '../../GiftDetailHeader/_components/HeroImage';

interface MobileHeroProps {
  heroImageUrlList: string[];
  adultYN: boolean;
}

export const MobileHero = ({ heroImageUrlList, adultYN }: MobileHeroProps) => {
  return (
    <div className="hidden mobile:block tablet:block">
      <HeroImage heroImageUrlList={heroImageUrlList} adultYN={adultYN} />
      <AgencyBanner />
    </div>
  );
};
